/**
 * @description å±æ§ æ¥ææ ¼å¼ç±»å
 *
 * @export
 */
export class PropertyDateFormatType {
  // å¹´æ
  static yearMonth = '2';
  // å¹´ææ¥
  static yearMonthDay = '3';
}

/**
 * @description å±æ§ æ¶é´æ ¼å¼ç±»å
 *
 * @export
 */
export class PropertyTimeFormatType {
  // æ¶å
  static hourMinute = '2';
  // æ¶åç§
  static hourMinuteSecond = '3';
}

// å°åºéæ©ç±»å
export enum RegionSelectionType {
  Province = 1,
  City = 2,
  District = 4
}
